var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.centrifuge.type !== 'slider')?_c('div',{staticClass:"timer"},[_c('div',{staticClass:"desc"},[_vm._v("До начала игры:")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("convertTime")(_vm.centrifuge.time)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }